// extracted by mini-css-extract-plugin
module.exports = {"editorContainer":"rich-text-editor_editorContainer__3e13d","controlToolbar":"rich-text-editor_controlToolbar__GmwWh","toolbarBtn":"rich-text-editor_toolbarBtn__1pqT-"};